import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function MoreThan200Section() {
  return <section className="bg-white py-16 px-4" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center" data-id="element-99">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-[#1f2e10] mb-10 leading-tight" data-id="element-100">
          Over 200+ kid-approved, nutritionist-backed recipes that are so tasty,{' '}
          <span className="text-green-600" data-id="element-101">
            your child will ask for seconds before the school bell rings!
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-2xl mx-auto rounded-3xl overflow-hidden shadow-xl" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/nEk6p79DMRMwj6knfRW6Sm/zkf75eJ1wFqsD9vx4ekqXj-img-2_1770402316000_na1fn_dmlhbmRhLXNhbHVkYWJsZS1oZXJv.webp" alt="Healthy and colorful lunchbox" className="w-full h-auto object-cover" loading="lazy" decoding="async" data-id="element-103" />
        </motion.div>
      </div>
    </section>;
}